import React from 'react'
import image1 from '../../src/assets/images/business.jpg'
import image2 from '../../src/assets/images/hands.png'
import Card from "../components/AnimatedCard";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

const About = () => {
    const cards = [
        {
            
          title: "For Startups",
          text:
          "Having started our journey as a start-up firm and growing as a leading software Product Development Company, We best understand the pulse of a new Venture.",
         icon: (
                <div className="icon2">
                  <i className="fa fa-handshake-o about-icon" style={{ fontSize: '24px' }}></i>
                </div>
              )
        },
        {
          title: "For Enterprise",
          text:
          "An Enterprise eco-system is not just about making profits. They also serve as a societal pillar along with profits, they have a responsibility towards society.",            
         icon: (
                <div className="icon2">
                  <i className="fa fa-briefcase about-icon" style={{ fontSize: '24px' }}></i>
                </div>
              )
        }
      ];
  return (
        <div className="container mt-5" id="About">
    <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <div className="cyber-about-img text-center mb-30 mb-lg-0">
                <img src={image1} alt="VR" className="img-fluid"/>
                <div className="row g-0">
                    <div className="col-lg-5 col-sm-12">
                        <div className="sheild-img">
                            <img src={image2} alt="Sheild" className="img-fluid d-none d-lg-block"/>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="pe-2">
                            <div className="cyber-about-count-box d-md-flex bg-white p-4 mt-3">
                                <div>
                                    <h5 className="h6" style={{color:"#106eea"}}>Request for Call Back</h5>
                                    <p className="mb-0">Call Us: +1 (919) 267-9857</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 ">
            <h1 className="who mt-3" alt ="About Round Point">About Round Point</h1>
            <h5 className="signin-text">At Round Point., we have helped more than 100 businesses transform their IT operations.</h5>
           <p style={{textAlign:"justify"}}>Round Point Tech is a US based Software Development and Technology consulting firm that provides a broad array of customized solutions to clients throughout the United States and state-of-the-art solutions to make your business better. We cater to the needs of businesses, operating at small, medium and large tier.</p>
           <div className="row">
           

<Grid container spacing={4}>
      {cards.map((item, index) => (
        <Grid item xs={12} sm={12} md={6}key={index}>
          <Card
            style={{
              width: "100%",
              height: "220px",
              cursor: "pointer",
              boxShadow: "none", 
              transition: "transform 0.5s", 
              transformStyle: "preserve-3d", 
              backfaceVisibility: "hidden", 
              border: "none",
              
            }}
            className="card-3d"
          >
            <CardContent>
            {item.icon}
              <Typography gutterBottom variant="h5" component="div">
                
                <h4 className="title"><a href="" class="text-decoration-none title">{item.title}</a></h4>

              </Typography>
              <Typography variant="body2" color="text.secondary">
                
                <p  className="description">{item.text}</p>

              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>

        
    </div>
</div>
</div>
</div>

  )
}

export default About
